export default "__VITE_ASSET__Bhw3asR1__"